import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasCreatorAccess } from "../utils/authRoles";

export default function CreatorRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/signin" state={{ from: location }} replace />;
  if (!hasCreatorAccess(user)) {
    return <Navigate to="/lobby" state={{ from: location, denied: "creator" }} replace />;
  }

  return children;
}
